import {StorageHelper} from "./storageHelper";
import i18n from "../i18n"
import {
    CHANNEL_MODE,
    CLIENT_ADMIN_PERMISSION,
    COUNTRY_DEFAULT, CURRENCY,
    LANGUAGE,
    LIMIT_RECORDS_API, MONTH_LIST, ORDER_ITEM_TYPE,
    PAYMENT_MODE,
    RATE_TYPE,
    SHOWCASE_PRIVACY,
    STATE_ORDER,
    STATE_RESERVATION,
    STATUS_STRIPE_PAYOUNT,
    STRIPE_APPLICATION_FEE_PERCENT,
    STRIPE_BUSINESS_TYPE,
    STRIPE_FIXED_TAX,
    SUBSCRIPTION_CATEGORY,
    TIMEZONE_DEFAULT, URL_CURRENCIES,
    VAT_PERCENT, VIDEO_STATE, VIDEO_VISIBILITY
} from "./constants";

import moment from 'moment'
import {CURRENCY_DEFAULT} from "@/common/constants";
import {converter} from "@lemonneko/currency-converter";

export class Utils {
    static getRedirectPageNameByUser(user) {
        if (!user || !user.read_permissions || user.read_permissions.length === 0) {
          StorageHelper.setUser(null);
          StorageHelper.setToken(null);
          return "login";
        }

        if (user.read_permissions[0] === CLIENT_ADMIN_PERMISSION.ADMINISTRATION) {
          return "cash_report";
        } else if (user.read_permissions[0] === CLIENT_ADMIN_PERMISSION.CONFIGURATION) {
          return "rates";
        } else {
          return "calendar";
        }
    }

    static composeUrlWithLimitAndOffset(url, currentPage=1, limit=LIMIT_RECORDS_API) {
        return url + "?limit=" + limit + "&offset=" + (currentPage - 1) * limit;
    }

    static composeUrlWithInfiniteLimit(url) {
        return url + "?limit=99999999";
    }

    static getStringRateType(rateType) {
        switch (rateType) {
            case RATE_TYPE.COURSE:
                return i18n.t('rate_type.course');
            case RATE_TYPE.GROUP:
                return i18n.t('rate_type.group');
            case RATE_TYPE.INDIVIDUAL:
                return i18n.t('rate_type.individual')
        }
    }

    static getStringSubscriptionCategory(subscriptionCategory) {
        switch (subscriptionCategory) {
            case SUBSCRIPTION_CATEGORY.NORMAL:
                return i18n.t('subscription_category.normal');
            case SUBSCRIPTION_CATEGORY.CARNET:
                return i18n.t('subscription_category.carnet');
        }
    }

    static getStringPaymentMode(paymentMethod) {
        switch (paymentMethod) {
            case PAYMENT_MODE.CASH:
                return i18n.t('payment_mode.cash');
            case PAYMENT_MODE.POS:
                return i18n.t('payment_mode.pos');
            case PAYMENT_MODE.CREDIT_CARD:
                return i18n.t('payment_mode.credit_card');
            case PAYMENT_MODE.TRANSFER:
                return i18n.t('payment_mode.transfer');
            case PAYMENT_MODE.TO_PAY:
                return i18n.t('payment_mode.to_pay');
            case PAYMENT_MODE.OTHER:
                return i18n.t('payment_mode.other');
        }
    }

    static getStringOrderItemType(type) {
        switch (type) {
            case ORDER_ITEM_TYPE.RESERVATION_TYPE:
                return i18n.t('order_item_type.reservation');
            case ORDER_ITEM_TYPE.SHOWCASE_TYPE:
                return i18n.t('order_item_type.showcase');
            case ORDER_ITEM_TYPE.SUBSCRIPTION_TYPE:
                return i18n.t('order_item_type.subscription');
        }
    }


    static getStringPaymentModeExtend(paymentMethod) {
        switch (paymentMethod) {
            case PAYMENT_MODE.CASH:
                return i18n.t('payment_mode.paid')+ " (" + Utils.getStringPaymentMode(paymentMethod) +")";
            case PAYMENT_MODE.POS:
                return i18n.t('payment_mode.paid')+ " (" + Utils.getStringPaymentMode(paymentMethod) + ")";
            case PAYMENT_MODE.CREDIT_CARD:
                return i18n.t('payment_mode.paid')+ " (" + Utils.getStringPaymentMode(paymentMethod) + ")";
            case PAYMENT_MODE.TRANSFER:
                return i18n.t('payment_mode.paid')+ " (" + Utils.getStringPaymentMode(paymentMethod) + ")";
            case PAYMENT_MODE.TO_PAY:
                return Utils.getStringPaymentMode(paymentMethod);
            case PAYMENT_MODE.OTHER:
                return i18n.t('payment_mode.paid')+ " (" + Utils.getStringPaymentMode(paymentMethod) + ")";
        }
    }
    static getStringChannelMode(channelReservation) {
        switch (channelReservation) {
            case CHANNEL_MODE.OFFLINE:
                return i18n.t('channel_mode.offline');
            case CHANNEL_MODE.ONLINE:
                return i18n.t('channel_mode.online');
        }
    }

    static getStringReservationState(reservationState) {
        switch (reservationState) {
            case STATE_RESERVATION.STATE_PENDING:
                return i18n.t('reservation_state.pending');
            case STATE_RESERVATION.STATE_COMPLETED:
                return i18n.t('reservation_state.completed');
            case STATE_RESERVATION.STATE_CANCELED:
                return i18n.t('reservation_state.canceled');
            case STATE_RESERVATION.STATE_NO_SHOW:
                return i18n.t('reservation_state.no_show');
        }
    }

    static getStringOrderState(OrderState) {
        switch (OrderState) {
            case STATE_ORDER.STATE_CANCELED:
                return i18n.t('order_state.canceled');
            case STATE_ORDER.STATE_COMPLETED:
                return i18n.t('order_state.completed');
            case STATE_ORDER.STATE_PAYMENT_REQUIRED:
                return i18n.t('order_state.payment_required');
        }
    }

    static getClassLabelOrderState(OrderState){
        switch (OrderState) {
            case STATE_ORDER.STATE_CANCELED:
                return "label-danger";
            case STATE_ORDER.STATE_COMPLETED:
                return "label-success";
            case STATE_ORDER.STATE_PAYMENT_REQUIRED:
                return "label-warning";
        }
    }

    static getStringSubscriptionActive(active) {
        if (active) {
            return i18n.t('order_state.active');
        } else {
            return i18n.t('order_state.not_active');
        }
    }

    static getStringStripeBusinessType(type) {
        switch (type) {
            case STRIPE_BUSINESS_TYPE.COMPANY:
                return i18n.t('business_type.company');
            case STRIPE_BUSINESS_TYPE.INDIVIDUAL:
                return i18n.t('business_type.individual');
            case STRIPE_BUSINESS_TYPE.NON_PROFIT:
                return i18n.t('business_type.non_profit');
        }
    }
    static getStringStatusPayout = (state) => {
        switch (state) {
            case STATUS_STRIPE_PAYOUNT.PAID:
                return i18n.t('status_stripe_payout.paid');
            case STATUS_STRIPE_PAYOUNT.CANCELED:
                return i18n.t('status_stripe_payout.canceled');
            case STATUS_STRIPE_PAYOUNT.FAILED:
                return i18n.t('status_stripe_payout.failed');
            case STATUS_STRIPE_PAYOUNT.TRANSIT:
                return i18n.t('status_stripe_payout.transit');
            case STATUS_STRIPE_PAYOUNT.PENDING:
                return i18n.t('status_stripe_payout.pending');
            default:
                return i18n.t('status_stripe_payout.pending');
        }
    };

    static getClassLabelStatusPayout = (state) => {
        switch (state) {
            case STATUS_STRIPE_PAYOUNT.PAID:
                return "label-success";
            case STATUS_STRIPE_PAYOUNT.CANCELED:
                return "label-danger";
            case STATUS_STRIPE_PAYOUNT.FAILED:
                return "label-danger";
            case STATUS_STRIPE_PAYOUNT.TRANSIT:
                return "label-default";
            case STATUS_STRIPE_PAYOUNT.PENDING:
                return "label-warning";
            default:
                return "label-warning";
        }
    };
    static getClassLabelVisibilityVideo(state){
        switch (state) {
            case VIDEO_VISIBILITY.PUBLIC:
                return "label-success";
            case VIDEO_VISIBILITY.NOT_PUBLIC:
                return "label-warning";
        }
    }

    static getStringStateVideo = (state) => {
        switch (state) {
            case VIDEO_STATE.READY:
                return i18n.t('components.video.state.ready');
            case VIDEO_STATE.STATE_TO_UPLOAD:
                return i18n.t('components.video.state.to_upload');
            case VIDEO_STATE.STATE_TRANSCODING:
                return i18n.t('components.video.state.transcoding');
        }
    };

    static getStringVisibilityVideo = (state) => {
        switch (state) {
            case VIDEO_VISIBILITY.PUBLIC:
                return i18n.t('common.public');
            case VIDEO_VISIBILITY.NOT_PUBLIC:
                return i18n.t('common.not_public');
            default:
                return i18n.t('common.not_public');
        }
    };

    static getClassLabelReservationState(reservationState){
        switch (reservationState) {
            case STATE_RESERVATION.STATE_PENDING:
                return "label-warning";
            case STATE_RESERVATION.STATE_COMPLETED:
                return "label-success";
            case STATE_RESERVATION.STATE_CANCELED:
                return "label-danger";
            case STATE_RESERVATION.STATE_NO_SHOW:
                return "label-info";
        }
    }


    static getStringLanguage(language) {
        switch (language) {
            case LANGUAGE.IT:
                return  i18n.t('language.it');
            case LANGUAGE.EN:
                return  i18n.t('language.en');
        }
    }

    static getStringPrivacyShowcase(privacy) {
        switch (privacy) {
            case SHOWCASE_PRIVACY.ANYONE:
                return  i18n.t('components.showcase.privacy_anyone');
            case SHOWCASE_PRIVACY.PASSWORD:
                return  i18n.t('components.showcase.privacy_password');
            case SHOWCASE_PRIVACY.PURCHASED:
                return  i18n.t('components.showcase.privacy_purchased');
            case SHOWCASE_PRIVACY.NOT_VISIBLE:
                return  i18n.t('components.showcase.privacy_not_visible');
        }
    }

    static b64EncodeUnicode (str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
                match,
                p1
            ) {
                return String.fromCharCode("0x" + p1);
            })
        );
    }

    static getClassLabelSubscriptionActive(active){
        if (active) {
            return "label-success";
        } else {
            return "label-danger";
        }
    }

    static getNumberPageByCountLimit(count, limit) {
        let pagesNumber = Math.floor(count / limit);
        let pagesNumberRest = count %  limit;

        if (pagesNumberRest !== 0) {
            pagesNumber++
        }

        return pagesNumber;
    }

    static getDayOfWeekISO(isoDate) {
        let dayOfWeek = new Date(isoDate).getDay();
        if (dayOfWeek === 0) {
            return 6
        } else {
            return dayOfWeek - 1
        }
    }

    static getLongDateFromISO(isoDate) {
        let timezone = Utils.getDefaultTimezone();
        return new Date(isoDate).toLocaleDateString(i18n.locale, {
            hour: '2-digit',
            minute: '2-digit',
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            timeZone: timezone})
    }

    static getDateCalendarCell(isoDate) {
        let timezone = Utils.getDefaultTimezone();
        return new Date(isoDate).toLocaleDateString(i18n.locale, {
            month: 'numeric',
            weekday: 'short',
            day:'numeric',
            timeZone: timezone})
    }

    static getAppointmentDateStringFromIso(isoDate) {
        let timezone = Utils.getDefaultTimezone();
        return new Date(isoDate).toLocaleDateString(i18n.locale, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            timeZone: timezone})
    }

    /**
     * Conversion short from iso ISO8601 into readable string
     */
    static getShortDateStringFromISO(dateISO) {
        let date = new Date(dateISO);
        return Utils.getShortDateStringFromObj(date);
    };

    static getShortDateStringUTCFromISO(dateISO) {
        let date = new Date(dateISO);
        return Utils.getShortDateStringUTCFromObj(date);
    };

    static getBeatifyShortDateStringFromISO(dateISO) {
        let date = new Date(dateISO);

        let dateString = Utils.getAppointmentDateStringFromIso(date);

        let today = moment().startOf('day');
        let yesterday = moment().subtract(1, 'days').startOf('day');
        let tomorrow = moment().add(1, 'days').startOf('day');


        if (moment(date).isSame(today, 'd')) {
            dateString = i18n.t('common.time.today');
        } else if (moment(date).isSame(tomorrow, 'd')) {
            dateString = i18n.t('common.time.tomorrow');
        } else if (moment(date).isSame(yesterday, 'd')) {
            dateString = i18n.t('common.time.yesterday');
        }

        return dateString;
    };

    static getShortDateStringFromObj(obj) {
        let timezone = Utils.getDefaultTimezone();
        return new Date(obj).toLocaleDateString(i18n.locale, {
            day:'2-digit',
            month: '2-digit',
            year:'numeric',
            timeZone: timezone});
    }

    static getShortDateStringUTCFromObj(obj) {
        return new Date(obj).toLocaleDateString(i18n.locale, {
            day:'2-digit',
            month: '2-digit',
            year:'numeric',
            timeZone: 'UTC'});
    }


    /**
     * Conversion from iso ISO8601 into readable string
     */
    static getDateStringFromISO(dateISO) {
        return Utils.getShortDateStringFromISO(dateISO) + " " + Utils.getHourStringFromISO(dateISO);

    };

    static getDateArrayStringFromISO(arrayDate) {
        let newDateArray = [];
        for (let i = 0; i < arrayDate.length; i++) {
            newDateArray.push(Utils.getDateStringFromISO(arrayDate[i]));
        }
        return newDateArray;
    }

    static getHourStringFromISO(dateISO) {
        let format = 'HH:mm';
        let timezone = Utils.getDefaultTimezone();
        return moment(dateISO).tz(timezone).format(format)

    };

    static getHourStringFromISOLocal(dateISO) {
        let format = 'HH:mm';
        return moment(dateISO).local().format(format)

    };

    static getTimeZoneLocal() {
        let offsetHour = moment().local().utcOffset() / 60;
        let gmtOffset = "";
        if (offsetHour > 0) {
            gmtOffset  += "+"
        }
        gmtOffset += offsetHour;
        return moment.tz.guess(true) + " (UTC" + gmtOffset + ")"
    }

    static getStringOrNA(string) {
        if (string) {
            return string;
        }
        return '--'
    }

    static getGrossPriceOnlineWithCreditCard(price) {
        let price_float = parseFloat(price);
        let fee_without_vat = price_float * (STRIPE_APPLICATION_FEE_PERCENT / 100) + STRIPE_FIXED_TAX;
        let fee_with_vat = fee_without_vat + (fee_without_vat * VAT_PERCENT / 100);
        return (Math.floor((price_float + fee_with_vat) * 100) / 100).toFixed(2)
    }

    static getCurrencySymbolFromString(currency) {
        if (currency) {
            switch (currency.toUpperCase()) {
                case CURRENCY.EUR:
                    return "€";
                case CURRENCY.USD:
                    return "$";
                case CURRENCY.CAD:
                    return "$";
                case CURRENCY.CHF:
                    return "₣";
                case CURRENCY.GBP:
                    return "£";
                default:
                    return currency
            }
        } else {
            return currency
        }

    }

    static getCompanyCurrency() {
        let currency = CURRENCY_DEFAULT;
        let user = StorageHelper.getUser();
        if (user && user.company) {
            currency = user.company.default_currency
        }
        return currency;
    }

    static getDefaultCurrency() {
        let currency = CURRENCY_DEFAULT;
        let user = StorageHelper.getUser();

        let userConsumer = StorageHelper.getUserConsumer();
        let defaultCurrency = StorageHelper.getDefaultCurrency();

        if (userConsumer && userConsumer.default_currency) {
            currency = userConsumer.default_currency;
        } else if (user && user.default_currency) {
            currency = user.default_currency;
        } else if (defaultCurrency) {
            currency = defaultCurrency;
        }
        return currency;
    }

    static getDefaultCountry() {
        let country = COUNTRY_DEFAULT;
        let countryCodeStored = StorageHelper.getDefaultCountryCode();
        let user = StorageHelper.getUser();
        let userConsumer = StorageHelper.getUserConsumer();
        if (user && user.country) {
            country = user.country;
        } else if (userConsumer && userConsumer.country) {
            country = userConsumer.country;
        } else if (countryCodeStored) {
            country = countryCodeStored
        }
        return country;
    }

    static getDefaultTimezone() {
        let timezone = TIMEZONE_DEFAULT;
        let timezoneStored = StorageHelper.getDefaultTimeZone();
        let user = StorageHelper.getUser();
        let userConsumer = StorageHelper.getUserConsumer();
        if (user && user.timezone) {
            timezone = user.timezone;
        } else if (timezoneStored && timezoneStored.timezone) {
            timezone = userConsumer.timezone;
        } else if (timezoneStored) {
            timezone = timezoneStored
        }
        return timezone;
    }

    static getTranslationsPhoneField() {
        return ({
                countrySelectorLabel: i18n.t('phone_number_field.country_code_label'),
                countrySelectorError:  i18n.t('phone_number_field.country_code_error'),
                phoneNumberLabel: i18n.t('phone_number_field.phone_number_label'),
                example: i18n.t('phone_number_field.example'),
        })
    }

    static getDurationTime(totalSeconds) {

        let timeString = moment.utc(totalSeconds*1000).format('mm:ss');

        if (totalSeconds >= 3600) {
            timeString = moment.utc(totalSeconds*1000).format('HH:mm:ss')
        }

        return timeString;
    }

    static logoutConsumer() {
        StorageHelper.setUserConsumer(null);
        StorageHelper.setTokenConsumer(null);
    }

    static async getPriceString(price, price_currency) {
        let defaultCurrency = Utils.getDefaultCurrency();
        if (defaultCurrency !== price_currency) {
            return await converter.convert({
                to: defaultCurrency,
                from: price_currency,
                amount: price,
                url: URL_CURRENCIES
            }).then((result) => {
                return this.getCurrencySymbolFromString(defaultCurrency) + parseFloat(result.result).toFixed(2)
            }).catch((err) => {
                // catch the error
                console.log(err);
                return this.getCurrencySymbolFromString(defaultCurrency) + price
            })
        } else {
            return this.getCurrencySymbolFromString(price_currency) + price
        }
    }

    static async getPrice(price, price_currency) {
        let defaultCurrency = Utils.getDefaultCurrency();
        if (defaultCurrency !== price_currency) {
            return await converter.convert({
                to: defaultCurrency,
                from: price_currency,
                amount: price,
                url: URL_CURRENCIES
            }).then((result) => {
                return parseFloat(result.result).toFixed(2)
            }).catch((err) => {
                // catch the error
                console.log(err);
                return price
            })
        } else {
            return price
        }
    }

    static getMonthObjByValue = (month) => {
        for (let i = 0; i < MONTH_LIST.length; i++) {
            if (MONTH_LIST[i].value === month) return MONTH_LIST[i]
        }

        return MONTH_LIST[0]
    }
}


export const moveUpDatetimePopup = () => {
    let elWithClass = document.getElementsByClassName("vdatetime");
    if (elWithClass.length > 0) {
        for (let i = 0; i < elWithClass.length; i++) {
            if (elWithClass[i].childElementCount > 0) {
                let element = elWithClass[i].lastChild;
                if (element && element.style) {
                    element.style.zIndex = "9999";
                    element.style.position = "fixed";
                    document.body.appendChild(element)
                }
            }
        }
    }
};
